import { AST } from '../../ast';
import _ from 'lodash';
import { _Select } from '../../ast/rel';
import { relToEraQlAst } from '../to-eraql-ast/rel-to-eraql-ast';
import { buildNode } from '../formatter/Builder';
import { withNullMeta } from '../lex/types';
import { generateProgram } from '../formatter/Generator';

export const relToEraQL = (rel: AST.RelFR): string => {
  const eraQLAst = relToEraQlAst(rel);
  const formatNodeTree = buildNode(withNullMeta(eraQLAst));
  return generateProgram(formatNodeTree);
};
